import { useState } from "react";

import Phone from "../../Assets/Offers/Phone.svg";
import Email from "../../Assets//Offers/Email.svg";
import Location from "../../Assets/Offers/Location.svg";
import Design from "../../Assets/Offers/FormImage.png";

function GetInTouch() {
  function DateFieldWithPlaceholder() {
    const [inputType, setInputType] = useState("text");
    const [date, setDate] = useState("");

    const handleFocus = () => {
      setInputType("date");
    };

    const handleBlur = () => {
      if (!date) {
        setInputType("text"); // Revert to text if no date is selected
      }
    };

    return (
      <input
        type={inputType}
        value={date}
        onChange={(e) => setDate(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
        id="date"
        className="bg-inherit p-4 py-8 pl-0 text-base md:text-lg text-[#FFFFFF] border-b-2 w-full placeholder-white focus:outline-none"
        placeholder="Select date"
      />
    );
  }

  return (
    <div className="p-6 pt-4 md:px-16 md:py-8 flex flex-col md:flex-row w-full mt-4 md:mt-8 mb-8">
      <div
        className="flex flex-col w-[100%] pt-8 md:w-[55%] lg:w-[65%]"
        data-aos="fade-right"
      >
        <div className="hidden md:block text-center absolute right-0">
          <img
            src={Design}
            alt="Decorative Flower"
            className="mx-auto md:-mt-10 lg:-mt-16 md:-mr-1 md:w-[70%] lg:mr-auto lg:w-[90%] h-auto"
          />
        </div>
        <h2 className="text-[#FF8F61] italic text-xl md:text-2xl tracking-wide">
          Contact With US
        </h2>
        {/* <img src={FormImage} alt="A design image" className ="w-40 text-center"/> */}
        <h1 className="text-[#202020] text-3xl md:text-4xl lg:text-5xl my-4  md:my-6 font-serif font-bold tracking-wide">
          GET IN TOUCH
        </h1>
        <p className="text-[#6D6C6C] text-sm md:text-lg leading-relaxed">
          We’d love to hear from you! Whether you have questions about our
          services, want to schedule an appointment, or simply need more
          information, we’re here to help.
        </p>

        <div className="pt-4 flex items-center">
          <img src={Phone} alt="Phone" className="h-12 md:h-16" />
          <div className="flex flex-col p-4 pl-8">
            <p className=" text-[#6D6C6C] text-base md:text-lg md:leading-loose">
              Have any question?
            </p>
            <p className="text-md md:text-xl">+91-7327986868</p>
          </div>
        </div>

        <div className="pt-4 flex items-center">
          <img src={Email} alt="Email" className="h-12 md:h-16" />
          <div className="flex flex-col p-4 pl-8">
            <p className="text-[#6D6C6C] text-base md:text-lg md:leading-loose">
              Write Email
            </p>
            <p className="text-lg md:text-xl">kayaspa23@gmail.com</p>
          </div>
        </div>

        <div className="pt-4 flex items-center">
          <img src={Location} alt="Location" className="h-12 md:h-16" />
          <div className="flex flex-col pt-0 p-4 pl-8">
            <p className="text-[#6D6C6C] text-base md:text-lg md:leading-loose">
              Visit Now
            </p>
            <p className="text-md md:text-xl">
              Marwari Para, Jharsuguda, Odisha, 768201
            </p>
          </div>
        </div>
      </div>

      {/* Form Section starts here */}
      <div
        className="bg-[#ff6a00] rounded-md mt-4 px-8 md:mt-auto pt-8 md:pt-12 pb-0 md:w-[45%] lg:w-[35%] text-[#FFF5F2]"
        data-aos="fade-down"
      >
        <h2 className="italic text-2xl tracking-wide">Appointment</h2>
        <h1 className="my-2 md:text-4xl md:my-6 font-serif tracking-wide">
          BOOK NOW
        </h1>

        <form action="" className=" md:py-2 md:px-4 items-center">
          <input
            type="text"
            className="bg-inherit p-4 py-8 pl-0 text-base md:text-lg text-[#FFFFFF] border-b-2 w-full placeholder-white focus:outline-none"
            placeholder="Your Name"
          />

          <input
            type="text"
            className="bg-inherit p-4 py-8 pl-0 text-base md:text-lg text-[#FFFFFF] border-b-2 w-full placeholder-white focus:outline-none"
            placeholder="Email Address"
          />

          <select
            id="options"
            className="bg-inherit p-4 py-8 pl-0 text-base md:text-lg text-[#FFFFFF] border-b-2 w-full focus:outline-none"
          >
            <option value="" disabled selected hidden>
              Select service
            </option>
            <option value="Body Massages" className="text-black text-sm">
              Body Massages
            </option>
            <option value="Oil Therapy" className="text-black text-sm">
              Oil Therapy
            </option>
            <option value="Aroma Therapy" className="text-black text-sm">
              Aroma Therapy
            </option>
          </select>

          <DateFieldWithPlaceholder />
          <button className="my-8 py-3 px-12  text-[#FF4800] font-semibold w-full md:w-fit bg-white rounded">
            Book Now
          </button>
        </form>
      </div>
    </div>
  );
}

export default GetInTouch;
